// extracted by mini-css-extract-plugin
export default {"innerWrapper":"fw-z","tooltipWrapper":"gw-z","icon":"hw-z","tooltip":"iw-z","content":"jw-z"};